import React from "react";
import cn from "classnames";

import { User } from "../../types";

import styles from "./Header.module.scss";

interface UserMenuProps {
    menuOpen: boolean;
    user?: User;
    onSignOut?: () => void;
}

export const UserMenu = (props: UserMenuProps) => {
    const {
        menuOpen,
        user,
        onSignOut = () => { },
    } = props;

    return (
        <ul
            className={cn(styles.menu, styles.userMenu, { [styles.open]: menuOpen })}
            aria-label={`Hi ${user?.cropped_name}`}
        >
            <li className={ styles.menuItem }>
                <a
                    className={ styles.menuItemLink }
                    data-header-link="saved-companies"
                    href="/companies?favorited=true"
                >
                    Saved Companies
                </a>
            </li>
            {user?.view_bookings ? (
                <li className={ styles.menuItem }>
                    <a
                        className={ styles.menuItemLink }
                        data-header-link="booking-manager"
                        href="/dashboard/bookings"
                    >
                        Booking Manager
                    </a>
                </li>
            ) : null}
            {user?.company ? (
                <li className={ styles.menuItem }>
                    <a
                        className={ styles.menuItemLink }
                        data-header-link="company-settings"
                        href={`/clients/${user?.company.short_name}`}
                    >
                        Company Settings
                    </a>
                </li>
            ) : null}
            <li className={ styles.menuItem }>
                <a
                    className={ styles.menuItemLink }
                    data-header-link="account-settings"
                    href="/user"
                >
                    Account Settings
                </a>
            </li>
            <li className={ styles.menuItem }>
                <a
                    className={ styles.menuItemLink }
                    data-header-link="sign-out"
                    href="/user/logout"
                    onClick={onSignOut}
                >
                    Sign Out
                </a>
            </li>
        </ul>
    );
};

export { UserMenu as default };
